module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_12-8941ddf0454daa70bbd0ddc342afbef6.png";